import TeacherPostReviewDetail from 'pages/teacherSide/post/TeacherPostReviewDetail/TeacherPostReviewDetail';
import TeacherPostReviewList from 'pages/teacherSide/post/TeacherPostReviewList/TeacherPostReviewList';
import React from 'react';
import { Route } from 'react-router-dom';

//
// 4) 글쓰기
//
const BoardPostWriteEdit = React.lazy(
  () => import('pages/teacherSide/post/BoardPostWriteEdit/BoardPostWriteEdit'),
);
const NotePostWriteEdit = React.lazy(
  () => import('pages/teacherSide/post/NotePostWriteEdit/NotePostWriteEdit'),
);
const PersonalMessage = React.lazy(
  () =>
    import('pages/teacherSide/post/WritePersonalMessage/WritePersonalMessage'),
);
const YoutubeLink = React.lazy(
  () => import('pages/teacherSide/post/YoutubeLink/YoutubeLink'),
);

const WritableBoardList = React.lazy(
  () => import('pages/teacherSide/post/WritableBoardList/WritableBoardList'),
);

const TeacherPostDetail = React.lazy(
  () => import('pages/teacherSide/post/TeacherPostDetail/TeacherPostDetail'),
);

const PostViewer = React.lazy(
  () => import('pages/teacherSide/post/PostViewer/PostViewer'),
);

const ViewPersonalMessage = React.lazy(
  () =>
    import('pages/teacherSide/post/ViewPersonalMessage/ViewPersonalMessage'),
);

const RouteListTSPost = (
  <Route path="teacherSide/post/">
    {/* 쓰기 */}
    <Route
      path="writeBoardPost"
      element={<BoardPostWriteEdit mode="write" />}
    />
    <Route path="writeNotePost" element={<NotePostWriteEdit mode="write" />} />
    <Route
      path="editBoardPost/:postId"
      element={<BoardPostWriteEdit mode="edit" />}
    />
    <Route
      path="editNotePost/:postId"
      element={<NotePostWriteEdit mode="edit" />}
    />
    {/* 보조화면 */}
    <Route path="writeEdit/writableBoardList" element={<WritableBoardList />} />
    <Route path="writeEdit/personalMessage" element={<PersonalMessage />} />
    <Route path="writeEdit/youtubeLink" element={<YoutubeLink />} />

    {/* 보기 */}
    <Route
      path="boardPost/:postId"
      element={<TeacherPostDetail postType="boardPost" />}
    />
    <Route
      path="notePost/:postId"
      element={<TeacherPostDetail postType="notePost" />}
    />
    <Route
      path="notePost/:postId/personalMessage"
      element={<ViewPersonalMessage />}
    />
    <Route
      path="boardPost/:postId/viewers"
      element={<PostViewer postType="boardPost" />}
    />
    <Route
      path="notePost/:postId/viewers"
      element={<PostViewer postType="notePost" />}
    />
    <Route
      path="brandPost/:brandAcademyId/:postId"
      element={<TeacherPostDetail postType="brandPost" />}
    />

    {/* 검토 */}
    <Route path="review/">
      <Route index element={<TeacherPostReviewList />} />
      <Route
        path="mine/:postType/:postId"
        element={<TeacherPostReviewDetail scope="mine" />}
      />
      <Route
        path="inbox/:postType/:postId"
        element={<TeacherPostReviewDetail scope="inbox" />}
      />
    </Route>
  </Route>
);

export default RouteListTSPost;
